import { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { LogoExiros } from '@icons'

import { LoginContainer, StyledCol, StyledRow } from './components'

const LoginLayout: FC = () => {
  return (
    <StyledRow align="middle" justify="center">
      <LoginContainer>
        <StyledCol span={24}>
          <LogoExiros width={150} />
        </StyledCol>
        <Outlet />
      </LoginContainer>
    </StyledRow>
  )
}

export { LoginLayout }
